import Vue from 'vue';
import LoginForm from '@/components/pages/LoginPage/LoginForm.vue'
import ContactForm from '@/components/pages/ContactPage/ContactForm.vue'
import bannerGovernmentShutdown from '@/components/pages/LoginPage/bannerGovernmentShutdown.vue'

Vue.component('login-form', LoginForm);
Vue.component('contact-form', ContactForm);
Vue.component('banner-government-shutdown', bannerGovernmentShutdown);
